import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DebugApiService } from '../debug.service';

@Component({
    selector: 'app-debug-overview',
    templateUrl: './debug-overview.component.html',
    styleUrls: ['./debug-overview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DebugOverviewComponent implements OnInit {
  constructor(private readonly debugService: DebugApiService) {}

  mappingExceptions: any[];

  ngOnInit() {
    this.debugService.getMappingExceptions().subscribe(response => {
      this.mappingExceptions = response;
    });
  }
}
